import { render } from "./ModalUploadImage.vue?vue&type=template&id=3a715d4c&scoped=true"
import script from "./ModalUploadImage.vue?vue&type=script&lang=js"
export * from "./ModalUploadImage.vue?vue&type=script&lang=js"

import "./styles/ModalUploadImage.scss?vue&type=style&index=0&id=3a715d4c&lang=scss&scoped=true"
import "./ModalUploadImage.vue?vue&type=style&index=1&id=3a715d4c&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3a715d4c"]])

export default __exports__